import { CreateElement } from 'vue'
import Vue from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import camelcaseKeys from 'camelcase-keys'
import { v1 as uuidv1 } from 'uuid'

import { Body1, Body2, H6, Overline, Subtitle1 } from '@src/elements/typography/typography'

import { Icon } from '@src/elements/icon/icon'
import { Card } from '@src/components/card/card'

import WorkoutData from '@src/data/workout-data'
import { ExerciseResponse } from '@src/data/exercise-response'
import { WorkoutExercise } from '@src/data/workout-exercise'
import { WorkoutService } from '@src/service/workout'
import { Tooltip } from '@src/elements/tooltip/tooltip'

import '../workout-card.sass'
import { Modal } from '@src/elements/modal/modal'
import SessionManager from '@src/lib/session_manager'
// tslint:disable-next-line:no-duplicate-imports
import { Watch } from 'vue-property-decorator'

@Component
export class WorkoutCardSelect extends Vue {

  @Prop({ required: true })
  workout: WorkoutData

  @Prop({ required: false })
  counter: number

  protected showEquipmentPopup: boolean = false

  constructor (props) {
    super(props)
  }

  selectWorkout () {
    this.$store.dispatch('addWorkoutToTrainingDay', this.workout)
  }

  getWorkoutDetails (workoutId) {
    return new WorkoutService().getWorkout(workoutId)
      .then((response: any) => {
        return response.workout.workout_exercises!.map((attrs) => {
          let exercise = new ExerciseResponse(camelcaseKeys(attrs.exercise, { deep: true }))
          let workoutExercise = new WorkoutExercise(camelcaseKeys(attrs))
          workoutExercise.setExercise(exercise)
          return workoutExercise
        })
      })
  }

  @Watch('workout.id')
  async onWorkoutIdChanged (newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      this.workout.workoutExercises = await this.getWorkoutDetails(newVal)
    }
  }

  async created () {
    this.workout.workoutExercises = await this.getWorkoutDetails(this.workout.id)
  }

  render (h: CreateElement) {
    return <Card class={`workout-card workout-card-select ${SessionManager.Instance.isManager() && this.workout.hidden ? 'hidden-workout' : ''}`}>
      {this.renderHeader(h)}
      {this.renderPreview(h)}
      {this.renderTitle(h)}
      {this.renderSpecs(h)}
      {this.renderRight(h)}
    </Card>
  }

  renderHeader (h: CreateElement) {
    return <Overline slot='header' class='header'>
      <div class='tracked'>{this.workout.isCertified() ?
        <span><Icon name='workout/certified' />{this.$t('PAGE.CONTENT.WORKOUTS.TYPES.CERTIFIED_WORKOUT')} /&nbsp;</span> : ''}</div>
    </Overline>
  }

  renderPreview (h: CreateElement) {
    return <div slot='preview' class='workout-preview'>
      <img src={this.workout.displayImage} />
    </div>
  }

  renderTitle (h: CreateElement) {
    return <H6 class='title' slot='title'>
      {this.workout.name}
    </H6>
  }

  renderSpecs (h: CreateElement) {
    const firstFiveEquipmentItems = this.workout!.equipment.slice(0, 5).map((equipmentName) => {
      return <div key={uuidv1()} class='equipment'>
        <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.' + equipmentName.toUpperCase())}>
          <Icon name={'equipment/' + equipmentName} />
        </Tooltip>
      </div>
    })

    const allEquipmentItems = this.workout!.equipment.map((equipmentName) => {
      return <div key={uuidv1()} class='equipment'>
        <Icon name={'equipment/' + equipmentName} />
        <Body1>{this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.' + equipmentName.toUpperCase())}</Body1>
      </div>
    })

    return <div slot='specs' class='specs'>
      <div class='workout-detail'>
        <Icon name='workout/exercises' />
        <Subtitle1 class='detail-text'>{this.workout.exerciseCount} {this.$t('EXERCISES')}</Subtitle1>
      </div>
      <div class='workout-detail'>
        <Icon name='workout/time' />
        <Subtitle1 class='detail-text'>{this.workout.estimatedDurationInMin} {this.$t('UNITS.MIN')}</Subtitle1>
      </div>
      <div class='workout-detail'>
        <Icon name='workout/score' />
        <Subtitle1 class='detail-text'>{this.workout.estimatedMetValue} {this.$t('UNITS.MET')}</Subtitle1>
      </div>

      <div class='equipmentWrapper'>{firstFiveEquipmentItems}{this.workout!.equipment.length > 5 ?
        <Icon class='see-more' name='util/see-more' click={this.invertShowEquipment} /> : ''} </div>
      <Modal class={'training-equipment-modal'} show={this.showEquipmentPopup} closeCallback={this.invertShowEquipment}
             title={this.$t('EQUIPMENT')}>
        {allEquipmentItems}
      </Modal>
    </div>
  }

  invertShowEquipment () {
    this.showEquipmentPopup = !this.showEquipmentPopup
  }

  renderRight (h: CreateElement) {
    return <div slot='right'>
      <div class='row-btns'>
        {SessionManager.Instance.isManager() && this.workout.hidden ?
          <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.HIDDEN_WORKOUT')}>
            <Icon class='hidden' name={'workout/hidden-workout'} />
          </Tooltip> : null}
        <Tooltip content={this.$t('PAGE.CONTENT.TRAINING_PLAN.TRAINING_PLAN_BUILDER.DRAG_TO_ADD_TO_PLAN')}><Icon class='drag-btn' name='/util/drag' /></Tooltip>
        {this.counter === 0 ?
          <Tooltip content={this.$t('PAGE.CONTENT.TRAINING_PLAN.TRAINING_PLAN_BUILDER.ADD_TO_PLAN')}>
            <Icon class='add-btn' name='/util/add-circle-outline' click={this.selectWorkout} /></Tooltip>
          : <div class='add-more-btn' onClick={this.selectWorkout}>
            <span class='counter'>
              <Body2>{this.counter}</Body2>
              </span>
            <Tooltip content={this.$t('PAGE.CONTENT.TRAINING_PLAN.TRAINING_PLAN_BUILDER.ADD_TO_PLAN')}><Icon class='add-btn' name='/util/add-circle' /></Tooltip>
          </div>}
      </div>
    </div>
  }
}
